import React from "react";
import { SettingsFormCard } from "../components/setting-driver-form-card";
import SettingDriverService, { DriverSettingsPayload } from "../services/setting-driver-service";

const acceptTimeoutFields = [
  {
    name: "time",
    label: "Thời gian chờ tài xế xác nhận",
    placeholder: "Ví dụ: 15",
    type: "number",
    isRequired: true,
    helpText: "Thời gian (phút) chờ tài xế xác nhận nhận/giao đơn. Quá thời gian sẽ tự động hủy và gán cho tài xế khác. Áp dụng cho cả nhận hàng và giao hàng.",
    min: 1
  }
] as const;

const reminderIntervalFields = [
  {
    name: "time",
    label: "Tần suất nhắc nhở tài xế",
    placeholder: "Ví dụ: 1",
    type: "number",
    isRequired: true,
    helpText: "Tần suất (phút) gửi thông báo nhắc nhở tài xế xác nhận. Áp dụng cho cả nhận hàng và giao hàng.",
    min: 1
  }
] as const;

const SettingDriverPage: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-start h-full p-4 space-y-8">
      <SettingsFormCard<DriverSettingsPayload>
        title="THỜI GIAN CHỜ TÀI XẾ XÁC NHẬN"
        fields={acceptTimeoutFields}
        getDetails={SettingDriverService.getPickupAcceptTimeout}
        updateSettings={SettingDriverService.settingPickupAcceptTimeout}
        dataKey="accept_timeout"
      />
      <SettingsFormCard<DriverSettingsPayload>
        title="TẦN SUẤT NHẮC NHỞ TÀI XẾ"
        fields={reminderIntervalFields}
        getDetails={SettingDriverService.getReminderInterval}
        updateSettings={SettingDriverService.settingReminderInterval}
        dataKey="reminder_interval"
      />
    </div>
  );
};

export default SettingDriverPage;